import { Navigate } from "react-router";

// Redirect to home - Ideas are only available in the sidebar
export default function IdeasPage() {
  return <Navigate to="/" replace />;
}
